/**
 * ### convertMarkdownToHtml
 *
 * @description
 * Converts simple markdown syntax (*bold*, _italic_) and line breaks to HTML tags.
 * Also cleans up unwanted characters like carriage returns and zero-width spaces.
 *
 * @example
 * const html = convertMarkdownToHtml('This is *bold* and _italic_ text\nWith a line break');
 * // Returns: 'This is <b>bold</b> and <i>italic</i> text<br/>With a line break'
 *
 * @param text - The text containing markdown syntax and line breaks
 * @returns HTML string with converted markdown
 */
const convertMarkdownToHtml = (text: string): string => {
  let str = text;

  // Remove \r (carriage return) and \u200B (zero-width space) characters
  str = str.replace(/\r/g, ''); // Remove carriage returns
  str = str.replace(/\u200B/g, ''); // Remove zero-width spaces

  // Convert *bold* to <strong> tags
  str = str.replace(/\*([^*]+)\*/g, '<b>$1</b>');

  // Convert _italic_ to <em> tags
  str = str.replace(/_([^_]+)_/g, '<i>$1</i>');

  // Convert \n to <br> tags
  str = str.replace(/\n/g, '<br/>');

  return str;
};

export default convertMarkdownToHtml;
